import LazoRoleService from "@/services/LazoRoleService";
import LazoTeamService from "@/services/LazoTeamService";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const LAZO_TEAM_QUERY_KEY = "lazo-team";

// ========== QUERIES ==========

export function useLazoTeamOfCompany(companyExternalId: string) {
  return useQuery({
    queryKey: [LAZO_TEAM_QUERY_KEY, companyExternalId],
    queryFn: () => LazoTeamService.getLazoTeamOfCompany(companyExternalId, 0, 100).then((r) => r.getContentOrThrowError()),
    enabled: !!companyExternalId,
    placeholderData: keepPreviousData,
    initialData: { content: [], page: { size: 0, number: 0, totalElements: 0, totalPages: 0 } },
    select: (data) => data.content ?? [],
    meta: {
      errorMessage: "Error fetching company team members",
    },
  });
}

export function useLazoTeamOfCompanyPaged(companyExternalId: string, page: number, pageSize: number = 10) {
  return useQuery({
    queryKey: [LAZO_TEAM_QUERY_KEY, "of-company", companyExternalId, page, pageSize],
    queryFn: () => LazoTeamService.getLazoTeamOfCompany(companyExternalId, page, pageSize).then((r) => r.getContentOrThrowError()),
    enabled: !!companyExternalId,
    placeholderData: keepPreviousData,
    meta: {
      errorMessage: `Error fetching lazo team for company ${companyExternalId}`,
    },
  });
}

export function useEmployeeStats(lazoUserExternalId: string, activeWorkflowsOnly: boolean = true) {
  return useQuery({
    queryKey: [LAZO_TEAM_QUERY_KEY, "employee-stats", lazoUserExternalId, activeWorkflowsOnly],
    queryFn: () => LazoTeamService.getEmployeeStats(lazoUserExternalId, activeWorkflowsOnly).then((r) => r.getContentOrThrowError()),
    enabled: !!lazoUserExternalId,
    placeholderData: keepPreviousData,
    meta: {
      errorMessage: "Error fetching employee stats",
    },
  });
}

export function useEmployeeRole(lazoUserExternalId: string) {
  return useQuery({
    queryKey: [LAZO_TEAM_QUERY_KEY, "employee-role", lazoUserExternalId],
    queryFn: () =>
      LazoRoleService.getAllRolesForLazoUserWithinCompany("lazoTenant0", lazoUserExternalId).then((r) => {
        const roles = r.getContentOrThrowError();
        return roles[0] ?? null;
      }),
    enabled: !!lazoUserExternalId,
    meta: {
      errorMessage: "Error fetching user roles",
    },
  });
}
